"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Icon = function Icon(_ref) {
  var symbol = _ref.symbol,
      className = _ref.className;
  var classNames = ['glyphicon', "glyphicon-".concat(symbol)];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: classNames.join(' '),
    "aria-hidden": "true"
  });
};

Icon.propTypes = {
  symbol: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
Icon.defaultProps = {
  className: ''
};
var _default = Icon;
exports["default"] = _default;